module.exports = __webpack_public_path__ + "media/images/landkit/icons/figma-dark-circle-8cfe05c041ee41efc5103f0b7f0a6a05.png";